import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    CmpsDialogModule,
    CmpsIconModule,
    CmpsPortalModule,
} from '@cmps/ng-uikit';

import { CmpsCommonModule } from '../../../common/common.module';
import { CmpsLazyI18nModule } from '../../../i18n/i18n.module';

import { CaScoreSectionComponent } from './ca-score-section.component';
import { TranslationIdMap as ScoreSectionTranslationIdMap } from './ca-score-section.i18n';
import { ScoreSectionLegendComponent } from './component/score-section-legend/score-section-legend.component';
import { TranslationIdMap as ScoreSectionLegendTranslationIdMap } from './component/score-section-legend/score-section-legend.i18n';

@NgModule({
    declarations: [CaScoreSectionComponent, ScoreSectionLegendComponent],
    exports: [CaScoreSectionComponent],
    imports: [
        CmpsCommonModule,
        CmpsDialogModule,
        CmpsIconModule,
        CmpsLazyI18nModule.forChild(ScoreSectionLegendTranslationIdMap),
        CmpsLazyI18nModule.forChild(ScoreSectionTranslationIdMap),
        CmpsPortalModule,
        CommonModule,
    ],
})
export class CmpsCaScoreSectionModule {}
